import { axios_instance } from "@/api/api";

export interface RecordListRequest {
  agent_id: string;
  page: number;
  size: number;
  mode?: string;
}

export interface RecordResponse {
  data: RecordItem[] | null;
  total_filter: number;
}

export interface RecordItem {
  id: string;
  agent_id: string;
  action_id?: string;
  mode?: string;
  path: string;
  extension: string;
  duration?: number;
  created: number;
  modified: number;
}

// Per-agent paginated list of recorded commits, newest first.
export async function getRecordList(
  params: RecordListRequest,
): Promise<RecordResponse> {
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: "/api/v1/view/record/pagination",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ ...params }),
  };

  const response = await axios_instance.request<RecordResponse>(config);
  return response.data;
}

// Absolute API URL to stream/download a stored record file (.mp4/.wav) from MinIO.
// `path` is the full stored object key ("<agent_id>/<file>") as returned by the
// pagination endpoint; the backend route /view/record/:agent_id/:path splits it
// back into its two segments (same convention as the screenshot viewer).
export function getRecordUrl( path: string): string {
  return `/api/v1/view/record/${path}`;
}
